/**
 * Helper function to escape a string for JavaScript.
 * @param str The string to escape.
 * @returns The escaped string.
 */
export const escapeForJS = (str: string): string => {
  return str
    .replace(/\\/g, "\\\\") // Escape backslashes
    .replace(/"/g, '\\"') // Escape double quotes
    .replace(/'/g, "\\'") // Escape single quotes
    .replace(/\n/g, "\\n") // Escape newlines
    .replace(/\r/g, "\\r") // Escape carriage returns
    .replace(/\t/g, "\\t"); // Escape tabs
};
